// Meta Pixel — Petites Histoires, Grande Foi / Le Méga Pack de Paraboles Chrétiennes
// Chargé uniquement après consentement marketing (RGPD).
// Purchase et InitiateCheckout sont volontairement absents : ils sont gérés côté checkout ImpulTienda.

type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __phgfPixelInitialized?: boolean;
    __phgfPixelEventsSent?: boolean;
    phgfConsent?: {
      grant: () => void;
      revoke: () => void;
      status: () => "granted" | "not granted";
    };
  }
}

export const META_PIXEL_ID = "1387335376806060";
export const CONSENT_STORAGE_KEY = "phgf_consent_marketing";
export const CONSENT_EVENT = "phgf:consent-updated";

export function hasMarketingConsent(): boolean {
  try {
    return window.localStorage.getItem(CONSENT_STORAGE_KEY) === "granted";
  } catch {
    return false;
  }
}

// À appeler par le futur bandeau de consentement (ou CMP).
export function setMarketingConsent(granted: boolean): void {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, granted ? "granted" : "denied");
  } catch {
    /* stockage indisponible */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { granted } }));
}

// Point d'entrée global pour une CMP (Axeptio, Didomi…) ou pour tester depuis la console.
export function exposeConsentApi(): void {
  if (window.phgfConsent) return;
  window.phgfConsent = {
    grant: () => setMarketingConsent(true),
    revoke: () => setMarketingConsent(false),
    status: () => (hasMarketingConsent() ? "granted" : "not granted"),
  };
}

function loadBaseCode(): void {
  if (window.fbq) return; // déjà présent : on ne réinjecte jamais le script

  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

// Initialise le pixel et envoie PageView + ViewContent une seule fois par chargement de page.
export function initMetaPixel(): void {
  if (typeof window === "undefined" || !hasMarketingConsent()) return;

  loadBaseCode();
  const fbq = window.fbq;
  if (!fbq) return;

  if (!window.__phgfPixelInitialized) {
    fbq("init", META_PIXEL_ID);
    window.__phgfPixelInitialized = true;
  }

  if (!window.__phgfPixelEventsSent) {
    window.__phgfPixelEventsSent = true;
    fbq("track", "PageView");
    fbq("track", "ViewContent", {
      content_name: "Le Méga Pack de Paraboles Chrétiennes",
      content_category: "Produit numérique",
      content_type: "product",
      value: 19.9,
      currency: "EUR",
    });
  }
}
